// File: components/academySectionsComponents/LeadershipDevelopmentSection.jsx

import React from "react";
import "./LeadershipDevelopmentSection.css";

import {
  GraduationCap,
  BriefcaseBusiness,
  BadgeCheck,
  Users
} from "lucide-react";

// 👉 Background image (replace with your real image path)
import bgImage from "../../Assets/images/conference2.jpeg";

export default function LeadershipDevelopmentSection() {

  const leadershipPrograms = [
    {
      icon: <GraduationCap size={42} />,
      title: "Workshops & Retreats",
      description:
        "Engage in leadership courses and programs designed for systems-driven growth."
    },

    {
      icon: <BriefcaseBusiness size={42} />,
      title: "Retreats & Intensives",
      description:
        "Participate in immersive sessions that strengthen leadership capacity and execution."
    },

    {
      icon: <BadgeCheck size={42} />,
      title: "Certification Tracks",
      description:
        "Advance through certification tracks that validate and elevate leadership excellence."
    },

    {
      icon: <Users size={42} />,
      title: "Coaching & Mentoring",
      description:
        "Receive personalized coaching and mentorship to refine your leadership journey."
    }
  ];

  return (

    <section
      className="leadership-development-section"
      style={{
        backgroundImage: `url(${bgImage})`
      }}
    >

      <div className="leadership-development-overlay"></div>

      <div className="leadership-development-container">

        {/* Header */}
        <div className="leadership-development-header">
          <h2>Build and Cultivate Systematic Leadership</h2>
        </div>

        {/* Grid */}
        <div className="leadership-development-grid">

          {leadershipPrograms.map((item, index) => (

            <div className="leadership-development-card" key={index}>

              <div className="leadership-development-card-glow"></div>

              <div className="leadership-development-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
}